import React, { useMemo } from 'react'
import { IPHeader } from './interface'
import { useBlockedInstructors, useFave } from '../context'
import PageHeader from '../Availability/PageHeader'

const Header: React.FC<IPHeader> = ({ loading, instructors = [], instructor, onChange }) => {
  const fave = useFave()
  const blocked = useBlockedInstructors()

  const memoHeader = useMemo(() => {
    const isBlocked = blocked.isBlocked(instructor?.InstructorId)
    const faves = (fave.faveInstructors || []).map(({ InstructorId = '', Name = '' }) => ({
      label: Name,
      value: InstructorId,
    }))
    let defaultValue = faves.find(({ value }) => value === instructor?.InstructorId)?.label

    if (!defaultValue) {
      defaultValue = instructors?.find(
        ({ instructorInfo }) => instructorInfo?.InstructorId === instructor?.InstructorId
      )?.instructorInfo?.Name
    }

    return (
      <PageHeader
        loading={loading}
        options={
          isBlocked
            ? [
                {
                  label: instructor?.Name!,
                  value: instructor?.InstructorId!,
                },
              ]
            : faves
        }
        defaultValue={isBlocked ? instructor?.Name! : defaultValue || ''}
        instructorId={instructor?.InstructorId}
        onChange={onChange}
        disabled={isBlocked}
      />
    )
  }, [fave.faveInstructors, loading, instructors, instructor])

  return <>{memoHeader}</>
}

export default Header
